import SaveLink from "components/SaveLink/SaveLink";
import { Link } from "gatsby";
import Img from "gatsby-image";
import React from "react";
import { Button, Icon, Item } from "semantic-ui-react";

interface PostCardProps extends Article {
  useImage: boolean;
}

export const PostCard: React.FC<PostCardProps> = props => {
  const {
    id,
    slug,
    title,
    description,
    excerpt,
    tags,
    subscriberOnly = false,
    featuredImage,
    date,
    source,
    useImage,
    timeToRead,
  } = props;
  const featuredImgFluid = featuredImage?.childImageSharp.fluid;

  // @mobileBreakpoint            : 320px;
  // @tabletBreakpoint            : 768px;
  // @computerBreakpoint          : 992px;
  // @largeMonitorBreakpoint      : 1280px;
  // @widescreenMonitorBreakpoint : 1920px;
  return (
    <Item>
      {featuredImage && useImage && (
        <Img className="ui small image" fluid={featuredImgFluid} />
      )}

      <Item.Content>
        <Item.Header as={Link} to={slug}>
          {title}
        </Item.Header>
        <Item.Meta>
          {new Date(date).toLocaleDateString()} | {timeToRead} min read
          {/*| Updated TODO: add updated date */}
        </Item.Meta>
        <Item.Description>{description || excerpt}</Item.Description>
        <Item.Extra>{tags.join(", ")}</Item.Extra>
        <Item.Extra>
          <SaveLink as={Button} targetPage={slug} basic />

          {source && (
            <Button as="a" href={source} target="_blank" basic>
              <Icon name="code" size="small" />
              Source
            </Button>
          )}
        </Item.Extra>
      </Item.Content>
    </Item>
  );
};

export default PostCard;
